import { CURRENCY, DurationUnit } from '../interfaces';

export enum CreditProductType {
    CREDIT = 'credit',
    CREDIT_CARD = 'creditCard',
    MICRO_CREDIT = 'microCredit',
    MORTGAGE = 'mortgage',
    AUTO_CREDIT = 'autoCredit',
}

export enum CreditProductStatus {
    HIDDEN = 'hidden',
    ACTIVE = 'active',
    ARCHIVED = 'archived',
}

export interface CreditProduct {
    _id: string;
    name: string;
    alias: string;
    organization: string;
    type: CreditProductType;
    status: CreditProductStatus;
    purpose: string;

    description?: string;
    oldId?: string;
    kind?: string[];

    // Описаны не все поля. Смотри http://credits.svc.master.qa.sravni-team.ru/swagger
}
export interface CreditProductRatePeriod {
    term: {
        from: Duration;
        fromValue: number;
        fromUnit: DurationUnit;

        to: Duration;
        toValue: number;
        toUnit: DurationUnit;
    };
    rate: {
        from: number;
        to: number;
    };
}

export enum CustomerType {
    SALARY = 'salary',
    DEFAULT = 'default',
    BANK_CUSTOMERS = 'bank-customers',
}

export interface CreditProductRate {
    currency: CURRENCY;
    product: string;
    amount: {
        from: number;
        to: number;
    };
    periods: CreditProductRatePeriod[];
    isProgressive: boolean;
    customerTypes: CustomerType[];
    solvencyProofs: [];
    comment?: string;
    // Описаны не все поля. Смотри http://credits.svc.master.qa.sravni-team.ru/swagger
}

export interface CreditProductAdvertising {
    id: string;
    position: number;
    cost: number;
    actualCost: number;
    isPartner: boolean;
    priority: boolean;
    // Описаны не все поля. Смотри http://credits.svc.master.qa.sravni-team.ru/swagger
}
